import { useMutation } from "@tanstack/react-query";

import { useOpenModal } from "@/components/modal/utils/openModal";
import { isAxiosExpectedError } from "@/utils/zod-utils";

import { FavouriteApi } from "../favourite.api";
import { FavouritesResponseDTOError } from "../models";

type HookParams = { onSuccess?: () => void };

export const useSendFavourite = ({ onSuccess }: HookParams = {}) => {
  const { openModal } = useOpenModal();

  const openErrorModal = (message: string) => {
    openModal("INFORMATION_MODAL", {
      message,
      statusReg: "fail",
    });
  };

  return useMutation(FavouriteApi.sendAction, {
    onSuccess: (response) => {
      const errorCaseDTO = FavouritesResponseDTOError.safeParse(response);

      if (errorCaseDTO.success) {
        openErrorModal(errorCaseDTO.data.requestDTO.dataMap.error);
      } else {
        onSuccess && onSuccess();
      }
    },

    onError: (err) => {
      if (isAxiosExpectedError(err, FavouritesResponseDTOError)) {
        openErrorModal(err.response.data.requestDTO.dataMap.error);
      } else {
        openErrorModal("Unexpected error");
      }
    },
  });
};
